<template>
  <div
    v-if="$config && $config.debug === 'on'"
    class="debug-detail"
    :class="debugIsOpen ? '' : 'debug-info'"
    @click="debugIsOpen = !debugIsOpen"
  >
    <br>
    <pre>blackqueryResult: {{ blackqueryResult }}</pre>
    <br>
    <hr>
    <pre>debugInfo: {{ debugInfo }}</pre>
    <br>
    <hr>
    <pre>shortVideo: {{ shortVideo }}</pre>
    <br>
    <hr>
    <pre>originShortVideo: {{ originShortVideo }}</pre>
    <br>
  </div>
</template>

<script>
import { mapState } from 'vuex';

function beautifyJson(obj) {
  try {
    const jsonStr = JSON.stringify(obj, ' ', 2);
    return jsonStr;
  } catch (err) {
    console.log('beautifyJson fail', err);
  }
}

export default {
  data() {
    return {
      debugIsOpen: false,
    };
  },
  computed: {
    ...mapState('common', ['$config']),
    ...mapState('search', ['originResult', 'shortVideo', 'debugInfo']),
    blackqueryResult() {
      const { blackqueryResult } = this.originResult || {};
      return beautifyJson(blackqueryResult);
    },
    originShortVideo() {
      const { docs } = this.originResult || {};
      return beautifyJson(docs);
    },
  },
};
</script>

<style lang="scss">
.debug-detail {
  overflow-x: scroll;
}
.debug-info {
  height: 200px;
  overflow-x: scroll;
}
</style>
